import React, { Component } from "react";
import { Typography, Grid, Hidden } from "@material-ui/core";
import {
  RenderPageBanner,
  RenderSupportHeader,
  SupportQuickLinks,
} from "./CommonComponents";
import classnames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },

  bold: {
    fontWeight: "700",
  },
  paddingCell: {
    padding: 8,
  },
  subIndentation1: {
    marginLeft: "-20px",
  },
  centerAligned: {
    textAlign: "center",
  },
  bold: {
    fontWeight: "bold",
  },
});

export const TermsOfUseText = withStyles(styles)(function ({ classes }) {
  return (
    <>
      <div className={classnames(classes.spacer, classes.paperPadding)}>
        <Typography variant="body1" gutterBottom>
          The following terms and conditions (“Terms & Conditions”) shall be applicable to the enrollment in, use of, and availment by you of EastWest
          Bank’s online banking facility for business. By enrolling in and using our
          online banking facility, you hereby agree to be bound by these terms
          and conditions, which shall govern your relationship with us, as well as
          all transactions concluded by you or your authorized representative/s.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          1. About this terms and conditions
        </Typography>

        <Typography variant="body1" gutterBottom>
          1.1 As used in the succeeding paragraphs, “we”, “our”, “us”, the “Bank”
          and “EastWest Bank” refer to East West Banking Corporation. The terms
          “you” and “your” refer to every person including juridical entities and
          its authorized representative/s who has an account or opens an account
          with EastWest Bank.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          2. Definitions
        </Typography>
        <Typography variant="body1" gutterBottom>
          2.1. “Account/s” refers to all accounts accessible by you through the
          channels. <br /> <br />

          2.2. “Administrator” refer to the user’s role responsible for managing
          the process of user definition, modification and amendments, ensuring
          that the users have the appropriate permissions and responsibilities
          as required. <br /> <br />

          2.3. “Approver” refers to the user’s role that could approve transaction within the facility. <br /><br />

          2.4. “Average Daily Balance” or “ADB” refers to the average daily
          balance of the nominated account. <br /><br />

          2.5. “Business” refers to customers that were established either as a
          single proprietorship, partnership or corporation. <br /><br />

          2.6. “Channel” refers to any mode of access to our electronic services. <br /><br />

          2.7. “Credentials” refers to any information or identifiers used for
          authentication, verification or access control. This includes but is not
          limited to User IDs, card number, password, passcode, biometric identifiers, Personal Identification Number (PIN), security codes, One-Time
          Password (OTP) and Corporation Code. <br /><br />

          2.8. “CSF” refers to EastWest Business Banking Customer Set-up Form <br /><br />

          2.9. “Dual Control” refers to a specific role assigned to a separate
          users as Maker and another user as Approver, wherein the Maker has
          the authority to initiate the transaction or request and the Approver
          to approve same. <br /><br />

          2.10.“EastWest EasyBiz” refers to EWBC’s online banking facility
          for business accessible via <a href="https://business.eastwestbanker.com/" target="_blank">https://business.eastwestbanker.com/</a> or <a href="https://www.eastwestcorporate.com.ph/" target="_blank">https://www.eastwestcorporate.com.ph/</a> or via mobile application
          where business clients can access and transact using their accounts.<br /><br />

          2.11. “Electronic Services” refers to any banking and other services
          or facilities which we may offer to you from time to time via electronic
          means.<br /><br />

          2.12. “Facility” refers to the Bank’s online facility for business clients.<br /><br />

          2.13. “Government Agencies” refers to the following Bureau of Internal Revenue (BIR), Social Security System (SSS), Philippine Health
          Insurance Corporation (PhilHealth) and Home Development Mutual
          Fund (“Pag-ibig”).<br /><br />

          2.14. “Maker” refers to the user’s role that could initiate transaction
          within the facility. <br /><br />

          2.15. “Single Control” refers to the procedure that needs only one person to initiate and approve a transaction or request, thus, assuming the
          role of both Maker and Approver, which poses a higher risk compared
          with dual control. <br /><br />

          2.16. “System” refers to the Bank’s online facility for business clients. <br /><br />

          2.17. “User” or “Users” refers to individual/s authorized to access, use,
          and/or transact in the facility on behalf of the business account.  <br /><br />

          2.18. “Viewer” refers to the user’s role that could view account information within the facility. Conditions Governing EastWest Bank Accounts,
          these Terms and Conditions shall prevail insofar as Business Banking-related items are concerned.
        </Typography>

        <br />


        <Typography variant="h6" color="primary" className={classes.bold}>
          3. Electronic access to your Account and/or Service
        </Typography>
        <Typography variant="body1" gutterBottom>
          3.1. Our electronic services are available through different devices (i.e.
          personal computers or mobile devices). The features of our electronic
          services may vary and the access and functions may differ depending
          on the type, system specifications and configuration of your device. In
          order to secure your account, we may require certain standard of specification, software version and such other technical requirements of your
          device used to access our electronic services.  <br /><br />


          3.2. If you access our electronic services outside of the Philippines, your
          access may be limited and subject to the relevant laws and regulations
          of that country. We will not be responsible for any fees, charges and
          expenses which may be imposed by your telecommunication or other
          service providers in connection with the use of our electronic services.  <br /><br />

          3.3. There may be circumstances where we may need to change the
          frequency and manner of use of our electronic services, transaction
          or daily limits, operating hours and types of facilities and services. In
          certain situations, we may have to suspend the electronic services. You
          agree that under such circumstances, we will not be responsible for any
          inconvenience, loss, damage or injury suffered by you or any third party, or any other similar circumstances beyond the reasonable control of
          the Bank. We will notify you of such changes or suspensions whenever
          reasonably possible.   <br /><br />

          3.4. We trust that you will use our electronic services in accordance with
          all applicable laws, regulations, guidelines and within our reasonable
          expectations. You shall not use our electronic services for any purposes
          which are not authorized by us.   <br /><br />

          3.5. You agree that we may provide you with user guides, procedures,
          any technical or functional specifications and / or other materials and
          instructions for the access to, operation, and use of Services. You have
          read, understood, and assessed all such materials and determined that
          they are adequate to protect your interests.   <br /><br />

          3.6. You agree you have taken reasonable steps to detect, prevent, remove and remedy any unauthorized access to or use of the facility (including actual or potential Malware breaches of client systems).   <br /><br />

          3.7. You agree that you have adequate internal controls, procedures,
          processes and other security arrangements to prevent unauthorized access to or use of the facility, and that in case of Single Control, you assume all the risks and hold the Bank free and harmless for any resulting
          damage to you as a result of adopting the Single Control transaction
          procedure.   <br /><br />

          3.8. You agree to use the facility within the authorization limits and functionality parameters you set up. <br /><br />

          3.9. You agree that you must immediately report any (i) actual or potential Loss suffered by you in connection with the facility; (ii) actual or
          attempted loss, theft, misuse or unauthorized use of System Materials or
          any credentials; (iii) actual or potential problems with unauthorized access to the facility; (iv) actual or attempted unauthorized transactions; or
          (v) failure to comply with user guides, procedures or other specifications.
          You will help us with our reasonable requests to resolve such problems;
          3.10. You agree that we may provide you with Software necessary for
          you to use the electronic services. You are responsible for ensuring that
          you have the necessary consent to install, configure and integrate the
          Software with your systems.  <br /><br />

          3.11. You agree that you are responsible for using, having or obtaining
          the necessary connectivity, hardware, software and other equipment for
          using the facility that is suitable and satisfies your requirements. You are
          solely responsible for obtaining all necessary consents and for compliance with any conditions of use or charges associated with your use of
          any channel, equipment, or service accessed through that equipment
          within your organization. You are responsible for any credentials we
          provide to you or which you use to access an online service to communicate with us electronically or give us instructions.  <br /><br />

          3.12. You agree that we may engage third party service providers (including payment, clearing or settlement systems, clearing houses, payment intermediaries, financial institutions or any subsidiary or affiliate of
          Filinvest Development Corporation) to be able to provide the Electronic
          Services which services are dependent on and subject to the performance of the third party service provider.
        </Typography>
        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          4. Use of electronic services
        </Typography>

        <Typography variant="body1" gutterBottom>
          4.1. Should you opt to implement the single control user role, you acknowledge and agree that the decision to implement a single control
          user role rather than a dual control user role is made entirely at your
          own risk. The Bank shall not be held liable for any losses or damages
          arising from this decision.  <br /><br />

          4.2. You agree that you and your users shall be solely responsible for
          keeping your credentials strictly confidential. For security reasons, you
          shall ensure that your users change their Password/s regularly, especially if they suspect that its confidentiality has been compromised. The
          Password designated by the User must not relate to any readily accessible personal data such as name, birth date, address, phone number, or
          identification card number and must not be an obvious combination of
          letters and numbers, including sequential numbers (e.g. 123456) or one
          which can easily be guessed by someone else. You and your users agree
          to jointly and severally indemnify and render us free and harmless from
          and against any claim or liability which may arise from the unauthorized
          use or misuse or breach of the confidentiality of the credentials.  <br /><br />

          4.3. You agree that any and all transactions made using the user’s credential shall be deemed by the Bank as official and binding upon with
          you and as having been authorized by the latter.  <br /><br />

          4.4. You agree that you and your users shall not use or permit the use of
          their credentials in whole or in part to carry out illegitimate and unlawful
          banking transactions via our electronic services. <br /><br />

          4.5. You agree that your users understand and will comply with all
          relevant requirements in the EastWest Business Banking Agreement as
          well as the General Terms and Conditions governing EastWest Deposit
          Accounts, which can be found in EastWest corporate website <a href="https://www.eastwestbanker.com/pages/general-terms-and-conditions-governing-eastwest-deposit-accounts" target="_blank">(https://www.eastwestbanker.com/pages/general-terms-and-conditions-governing-eastwest-deposit-accounts)</a> and the Privacy Statement, which can
          be found in EastWest corporate website <a href="https://www.eastwestbanker.com/privacystatement" target="_blank">(https://www.eastwestbanker.com/privacystatement)</a>.  <br /><br />

          4.6. You agree to promptly inform us of any changes to your Users.
          These changes will not take effect until we have processed them. If we
          are unable to process the changes, we will notify you as soon as possible. You remain responsible for all transactions that occur while your
          request is being processed.  <br /><br />

          4.7. You agree that you remain liable for all acts and transactions of your
          user during the period that such person has been granted access and
          use of the electronic services. <br /><br />

          4.8. The electronic services may be available through mobile application. The mobile application allows your user to authorize transactions,
          view report or obtain information about your account or service.  <br /><br />

          4.9. We may enhance our electronic services from time to time. If such
          changes are not suitable for your needs or any new or existing functionality causes you concern, you agree to immediately communicate
          with us so that we can discuss alternative solutions. You agree that any
          modified or additional service functionality will continue to be governed
          by the Agreement.  <br /><br />

          4.10. You or your user choose to activate or use any feature that enables access to and/or use of biometric credentials on any device or
          application (including without limitation fingerprint or facial recognition
          features), you acknowledge and agree that such features are provided
          by device and not by us and we have no obligations or responsibilities
          to you or your users in relation to such features. We expressly exclude
          any guarantee, representation, warranty, condition, term or undertaking
          of any kind relating to or arising from the functionality, compatibility or
          availability of such features and whether they meet your requirements.
          You accept that there are risks associated with the accuracy, reliability
          and/or availability of such features on the device to authenticate the
          identity of you and/or your user, which may allow unauthorized third
          parties to gain access to any device or application secured using biometric credentials and transmit to us instruction that are referrable to your
          credentials. You agree to assume such risks to the maximum extent permitted under applicable law, and we may act and rely on any instruction
          referrable to your or your users’ credentials.

        </Typography>


        <Typography variant="h6" color="primary" className={classes.bold}>
          5. Transaction Services
        </Typography>


        <Typography variant="body1" gutterBottom>
          5.1. You agree that we may specify limits on how much you need to
          have in your Account, the type of currencies that we may accept, as
          well as our usual charges commission and interest rates and any other
          requirements.  <br /><br />

          5.2. You are responsible for ensuring that your account is active with
          sufficient funds to cover for your transaction at all times. Any charges or
          penalties as a result of an unsuccessful transaction due to insufficiency of
          funds or account dormancy will be for the account of and paid by you.  <br /><br />

          5.3. You agree that we may implement cut-offs during the day for the
          electronic services. If the transaction is carried-out after the cut-off time,
          it shall be processed on the next banking day. Any charges or penalties
          as a result of the next day transaction will be for the account of and paid
          by you. We will notify you of such changes or suspensions whenever
          reasonably possible. <br /><br />

          5.4. You shall promptly notify us in case any error in the transaction is
          carried out through our electronic services via electronic mail or other
          reasonable means of communication. We will investigate the reported
          error and advise you of the result. We will, on a best efforts basis, and
          without any guarantee, correct or reverse any reported error without us
          incurring liability as a consequence thereof. <br /><br />

          5.5. Upon receipt by us and/or by you of any notice or order of restriction, legal or contractual, including-notices of garnishment or hold-out
          on or with respect to any enrolled account, you shall promptly stop or desist from carrying out any transaction that will defeat the purpose of
          the restriction and shall not make or do transactions with respect to said
          account for as long as the account restriction is effective or until it shall
          have been lifted, removed or totally implemented. <br /><br />
        </Typography>

        <Typography variant="h6" color="primary" className={classes.bold}>
          Account Statement
        </Typography>

        <Typography variant="body1" gutterBottom>
          5.6. We may send your Account statements, confirmations and advice
          through an appropriate Channel or by any other method we have
          agreed with you.  <br /><br />

          5.7. You must check your Account statements, confirmations and advice
          carefully. You must inform us in writing of any mistakes or unauthorized
          transactions as soon as possible and no later than ten (10) days from
          the transaction date (or such other period specified in the relevant statement, confirmation or advice). If you fail to do so we may consider them
          as correct. If you do not receive any Account statements, confirmations
          or advice from us, please visit any of our stores/ branches, our website at <a href="www.eastwestbanker.com" target="_blank">www.eastwestbanker.com</a>, or call our customer service hotline to
          speak to our customer service officer.
        </Typography>


        <Typography variant="h6" color="primary" className={classes.bold}>
          Fund Transfers
        </Typography>

        <Typography variant="body1" gutterBottom>
          5.8. We may accept an instruction to transfer funds between your account and any other account of yours or any other person maintained
          with us or with other bank. <br /><br />

          5.9. You are responsible for giving us the correct information. If your
          instructions identify the payee both by name and by account number,
          We, who receive your instructions may process such instructions solely
          based on the account number without the need to validate the name.
          Thus, in case of discrepancy, between the account number and name,
          the account number matching shall suffice to complete the instructions
          received by the Bank. For inter-bank transfers, processing rules of beneficiary bank shall apply to your transaction.  <br /><br />

          5.10. Scheduled or future dated transaction once approved by you and/
          or your users shall be processed based on the scheduled date, unless
          cancelled by the user one (1) day prior to its posting. <br /><br />

          5.11. We are not responsible for and have no duty to check any information you give us in your payment instructions. <br /><br />

          5.12. You authorize us to send your instructions on your behalf to other
          third-party service providers, to carry out your payment instructions. Processing shall be subject to the third-party service provider’s transaction
          cutoff and guidelines. <br /><br />

          5.13. You shall ensure that your account is sufficiently funded on the day
          of actual processing of your instruction. <br /><br />

          5.14. Under no circumstances, you shall withhold, stop or reverse the
          processing of your instructions once the said request has been confirmed
          by you. We shall have no obligation to reverse any amount that has
          already been executed.
        </Typography>

        <Typography variant="h6" color="primary" className={classes.bold}>
          Currency Conversion
        </Typography>

        <Typography variant="body1" gutterBottom>
          5.15. You agree that we may convert currencies for any amounts received from you or due to you, or as instructed, including electronically, using our prevailing exchange rate available on our website. If we
          confirm a foreign exchange transaction orally, over the telephone or
          electronically, it is binding from that confirmation.
        </Typography>

        <Typography variant="h6" color="primary" className={classes.bold}>
          Bills Payment
        </Typography>

        <Typography variant="body1" gutterBottom>
          5.16. We may accept an instruction to pay bill from your account to the
          biller account. <br /><br />

          5.17. You are responsible for giving us the correct payment information.
          We shall process the payment instruction based on the information/s that
          the platform shall require from you.<br /><br />

          5.18. We are not responsible for and have no duty to check any information you give us in your payment instructions. <br /><br />

          5.19. You authorize us to send your payment instructions on your behalf
          to payment intermediaries and other third-party service providers, so as
          to carry out your payment instructions. <br /><br />

          5.20. You agree that we may set limits on your bills payment transactions.<br /><br />

          5.21. You agree that scheduled or future dated transaction once approved by you and/or your users shall be processed based on the scheduled date, unless cancelled by the user one (1) day prior to its posting. <br /><br />

          Post-dated Check Warehousing &nbsp; &nbsp; <i class="fa-regular fa-square"></i> Product Not Availed <br /><br />


          5.22. We may accept an instruction from you to safekeep your checks
          with us. <br /><br />

          5.23. We shall only accept local or regional checks that is payable to
          you or payable to “Cash”. We shall not accept checks with second or
          multiple endorsements.  <br /><br />

          5.24. You shall stamp the deposit account number at the back of each
          check and deliver them to us at least ten (10) banking days before their
          maturity date.  <br /><br />

          5.25. You shall submit to us the transmittal file, conforming to our standards, through our channel.  <br /><br />

          5.26. You shall primarily be responsible for checking any technical defects of the submitted checks (such as alterations whether signed or unsigned, lacking in signature, no amount in words, and others). We shall
          return the checks and inform you immediately of any other defects that
          could be detected by us. <br /><br />

          5.27. You must acknowledge the accuracy of or dispute the check details
          within three (3) banking days from the date of the report was made
          available, otherwise, the check details that was submitted will be presumed accurate. <br /><br />

          5.28. On the check’s maturity date, we shall deposit the checks to your
          deposit account. Reports shall be made available in our channel. <br /><br />

          5.29. We shall provisionally credit your deposit account until such time
          the check has been cleared and credited to us. <br /><br />

          5.30. We shall debit your account for any returned or dishonored checks
          including charges associated with it. <br /><br />

          5.31. We shall notify you of the returned or dishonored checks on the
          day it was received. <br /><br />

          5.32. We shall not redeposit any checks without your expressed consent
          or advise. Redepositing of returned or dishonored checks shall be subject to the guidelines of the Philippine Clearing House.
          5.33. You may instruct us to hold, pullout or replace the checks through
          the channel. Checks that are put on hold shall not be deposited unless
          you instruct us to lift the hold status. <br /><br />

          5.34. We shall immediately credit all cleared funds to your account. <br /><br />

          Check Printing &nbsp; &nbsp; <i class="fa-regular fa-square"></i> Product Not Availed <br /><br />

          5.35. We may accept instruction from you to prepare check/s payable
          to your payees.<br /><br />

          5.36. Depending on your instructions, we can print your checks either
          through our manager’s check or through your commercial check at our
          premises or at your premises.<br /><br />

          5.37. You shall be responsible in providing us a copy digital signature
          that shall be printed to your commercial check or your wet signature
          signed in the commercial check, whenever applicable.<br /><br />

          5.38. You shall ensure that necessary approvals have been secured on
          the use of the submitted specimen signature (wet or digital).<br /><br />

          5.39. You may file for stop payment order for issued commercial checks,
          subject to our guidelines on stop payment order.<br /><br />

          5.40. You will be responsible in monitoring the accuracy and correctness
          of the transactions authorized or undertaken by your users using the
          channel.<br /><br />

          5.41. You shall provide us with your list of payees at least three (3)
          banking days prior to check printing. You shall confirm the list of payees
          through the requisite Letter of Authorization sent by fax the same day
          the list of payees was sent to enable us to check the accuracy of the
          payees and payment data, when applicable. <br /><br />

          Check Disbursement &nbsp; &nbsp; <i class="fa-regular fa-square"></i> Product Not Availed <br /><br />

          5.42. We may accept instruction from you to disburse check to your
          payees. <br /><br />

          5.43. Once the check/s have been printed, you may instruct us to disburse the printed check through the following:

          <ol style={{ listStyleType: "upper-alpha" }}>
            <li>Store or Branch of Account; or
              <ol style={{ listStyleType: "lower-roman" }}>
                <li>During check releasing, we shall rely on the submitted list of payees and shall not release any printed checks to any person not included in the list of payees.</li>
                <li>We shall require proper and valid identification from the payee or its authorized representative to whom the printed checks shall be released. Failure on the part of payee or its authorized representative to present proper and valid identification shall constitute sufficient reason for the non-re- lease of the check.</li>
                <li>We shall require the payee or its authorized represen- tative to issue the requisite Official Receipt or Provisional Receipt. No check shall be released to any payee or its authorized representative who does not issue the Official Receipt or Provisional Receipt.</li>
              </ol>
            </li>
            <li>To your designated address</li>
          </ol>

          <br />

          5.44. We shall disburse checks only during banking hours.     <br /><br />

          Account Sweeping  &nbsp; &nbsp; <i class="fa-regular fa-square"></i> Product Not Availed <br /><br />

          5.45. We may accept instruction from you to sweep your accounts at a
          designated date or at a designated account balance level. <br /><br />

          5.46. You shall ensure that your account is sufficiently funded in the day
          of actual processing of your instruction.  <br /><br />

          5.47. Under no circumstances, you shall withhold, stop or reverse the
          processing of instructions once the said request has been confirmed by
          you. We shall have no obligation to reverse any amount that has already
          been executed.<br /><br />

          5.48. On the day of the execution of instruction and in the event that
          there is an account that should not have been debited or that any transactions are to be withheld, but were included in the said request, or
          if there are changes, amendments, modifications, alterations or corrections to said uploaded or transmitted collection file, we shall have no
          obligation to reverse any amount that has been debited.<br /><br />

          Auto-Debit Arrangement   &nbsp; &nbsp; <i class="fa-regular fa-square"></i> Product Not Availed <br /><br />

          5.49. We may accept instruction from you to debit your authorized
          payor account and credit the proceeds to your account at a designated
          collection date.<br /><br />

          5.50. You shall be responsible in enrolling using bank forms and securing authorization to debit from your payor account in our channel.<br /><br />

          5.51. We shall execute instruction based on the submitted collection file.
          We shall not process debit instructions from payor accounts that are not
          enrolled, beyond its authorized limit or beyond its intended duration.<br /><br />

          5.52. Under no circumstances, you shall withhold, stop or reverse the
          debiting of your payor account. We shall have no obligation to reverse
          any amount that has already been debited from your payor account.

        </Typography>

        <Typography variant="h6" color="primary" className={classes.bold}>
          e-Gov Transactions
        </Typography>

        <Typography variant="body1" gutterBottom>
          5.53. You agree to use our facility for the filing and settlement of your
          payments to government agencies.<br /><br />

          5.54. You and your user shall be assigned corresponding credentials
          in order to transact. For further information, please refer to details contained in the materials that we have provided to you and your user.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          6. Notification Services
        </Typography>

        <Typography variant="body1" gutterBottom>
          6.1. You and your user shall be solely responsible for checking the status
          of your transactions by logging on to the facility from time to time. The
          system will nevertheless automatically send notifications to your users
          enrolled in the facility.<br /><br />

          6.2. You and your user shall provide correct and operational e-mail addresses and/or mobile phone number/s and shall ensure and hereby
          warrant the correctness of the Information entered.<br /><br />

          6.3. You likewise agree that you shall be responsible for keeping the
          confidentiality of the information contained in the notifications sent to the
          designated e-mail address and/or mobile phone number/s. We shall not
          be liable for any unauthorized disclosure or use of such information by
          you and/or your user.<br /><br />

          6.4. You shall promptly update us of any change in your contact information/s or any other information which may affect communication. Prior
          to such change, we shall have the right to rely upon and send/receive
          notifications to/from contact information as indicated in the CSF, without
          the Bank incurring liability as a consequence thereof.<br /><br />

          6.5. You shall be responsible, at your own expense, for providing the
          proper equipment, subscription, membership, internet connection, and
          other paraphernalia necessary and required to enable it to receive notifications from us. Your ability to receive notifications depends on the
          availability of these resources and the BANK does not endorse nor guarantee any third-party service or product for this purpose.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          7. ADB fees and charges
        </Typography>
        <Typography variant="body1" gutterBottom>
          7.1. You agree to maintain the minimum monthly ADB set for availing any
          of the facility and/or electronic services.<br /><br />

          7.2. We may, from time to time, upon giving notice, impose fees and
          charges for your use of the facility.<br /><br />

          7.3. You hereby authorize us to debit your nominated account/s for the
          amount of such fees and charges. If at any time there are insufficient
          funds in the said accounts to cover fees and charges, we may refuse to
          carry out transaction without the Bank incurring any liability as a result
          of such refusal.<br /><br />

          7.4. Any and all taxes arising from the use and availment of the facility,
          including payments made hereunder, shall be for your account.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          8. Termination / Suspension of Access and Use
        </Typography>
        <Typography variant="body1" gutterBottom>
          8.1. You may request the termination or suspension of access to and use
          of the facility by submitting a written request addressed to our Account
          Officer, Store Manager or Sales Officer managing the account. You
          shall remain responsible for any transactions, including any remaining
          scheduled transactions, made on the account until the time the Bank
          receives the letter of termination or suspension.<br /><br />

          8.2. We may terminate or suspend your access to and use of the facility at any time, subject to at least thirty (30) days prior notice of such
          termination.<br /><br />

          8.3. We may terminate or suspend your access to and use of the electronic services without prior notice if you have breached these Terms &
          Conditions;

          <ol style={{ listStyleType: "lower-alpha" }}>
            <li>We learn of your bankruptcy, insolvency, liquidation, dissolution or other analogous circumstances or that you committed an act of bankruptcy, insolvency, liquidation, dissolution or other analogous acts, or that a bankruptcy or in;</li>
            <li>No sufficient funds in the enrolled Account/s to cover payments or payment instructions given;</li>
            <li>If in our reasonable opinion, your enrolled Accounts are being mishandled as determined pursuant to the Bank&rsquo;s existing policies and procedures, or if the enrolled Accounts or the electronic services is being used for or suspected to any unlawful or illegal activity or transaction.</li>
            <li>We consider that there exist other reasonable grounds to do so (in which case all reasonable efforts will be made to advise you of the circumstances of termination or suspension); or</li>
          </ol>

          8.4. We may terminate this Agreement immediately upon written notice
          to you if so, required by BSP or other regulatory body or in compliance
          of a law or regulation. <br /> <br />

          8.5. Any and all accrued but unpaid obligations by you prior to termination, and terms and conditions hereof which by expressed terms, shall
          survive the termination of your access and use of the facility.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          9. Representations and warranties
        </Typography>

        <Typography variant="body1" gutterBottom>
          9.1. You represent and warrant to us that:
          <ol style={{ listStyleType: "lower-alpha" }}>
            <li>You are duly organized and validly existing under the laws
              of its place of incorporation, with the power to execute this
              Agreement and to exercise its rights and perform its obligations
              hereunder.</li>
            <li>Your users have the proper and necessary authority to act for and
              on your behalf in connection with the use and availment of the facility
              and carrying out transactions.</li>
            <li>All corporate or other actions required to authorize the execution
              and performance of its obligations hereunder have been duly taken;</li>
            <li>All authorizations, licenses and consents from governmental authorities in places where it has business presence, in respect of the
              execution and performance of this agreement have been duly taken;</li>
            <li>All authorizations and consents (including those of third parties)
              with respect to your enrollment of the Accounts in the facility, and
              allowing access, use of and transactions on said Account/s, have
              been duly taken;</li>
            <li>This agreement, when executed, will constitute its legal, valid,
              and binding obligation enforceable in accordance with the terms
              thereof; and</li>
            <li> During the effectivity of this agreement, it shall keep in full force
              and effect all authorizations, licenses and consents from government
              authorities, which is required by law in places where it has business
              presence in respect of the execution and performance of this agreement.</li>
          </ol>

          9.2. You shall ensure and hereby warrant to us that you and your users
          know their credentials and shall keep the credentials confidential. It is
          understood that your users are responsible in securing their account
          by periodically designating a new password to the electronic services
          platform.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          10. Indemnification Clause
        </Typography>

        <Typography variant="body1" gutterBottom>
          10.1. You hereby agree to indemnify and hold the Bank, its directors,
          officers, employees, and agents and assigns, free and harmless from and
          against any claim, cause of action, suit, liability, loss or damage of whatever nature which may arise as a result of or in connection with the use
          and your availment of the facility, and the implementation of facility’s
          transactions, and specifically in the following instances:
          <ol style={{ listStyleType: "lower-alpha" }}>
            <li>Disruption, failure, error or delay relating to or in connection with
              the facility, the implementation of transactions, transmission and/or
              receipt of messages, communications, materials, correspondences
              and/or information via the facility which is due to events such as but
              not limited to prolonged power outages, breakdown in computers
              and communication facilities, and/or which are attributable to payment and settlement EFT systems such as InstaPay and Pesonet and
              other gateway payments systems, which are beyond the control of
              the Bank.</li>
            <li>Fraudulent access or use of the facility and from any fraudulent
              or unauthorized transactions within the facility resulting from theft,
              unauthorized disclosure of credentials, or non-compliance with security requirements outlined in this Agreement, or any other fraudulent
              activities, caused by you, your representative or third-parties.</li>
            <li>Inaccurate, incomplete or delayed information that you received
              due to disruption or failure of any communication facilities used by
              the facility;</li>
            <li>Delay and/or failure to implement or carry out transactions on
              the account/s due to garnishment, execution, hold-out and similar
              restrictions on the Account/s; and/or unauthorized or fraudulent enrollment, use of, and transactions in the facility;</li>
            <li> Your inability, delay and/or failure to comply with the Terms &
              Conditions of this Agreement.</li>
          </ol>

          10.2. By opting to assign a single control user role rather than a dual
          control user role, you acknowledge and assume full responsibility for all
          associated risks. You agree to indemnify and hold the Bank, its officers,
          directors, and employees free and harmless from any claims or liabilities
          arising from or related to transactions authorized by the single control
          user. This indemnification includes, but is not limited to, unauthorized
          transactions, fraud, errors, or any other consequences resulting from the
          assignment of the single control user role. <br /> <br />

          10.3. We may terminate this terms & conditions immediately upon written notice to you if so, required by BSP or other regulatory body or in
          compliance of a law or regulation.<br /> <br />

          10.4. The above provisions shall survive the termination or suspension
          of the facility.
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          11. Proprietary and Disclosure Rights
        </Typography>

        <Typography variant="body1" gutterBottom>
          11.1. You agree that the facility, its website, the software used in connection therewith, any and all materials and information’ (including, modifications, enhancements, updates) used in or derived from the provision
          of the facility, associated marks, logos, business names, products and
          services (“Proprietary Items”) are proprietary and confidential to the
          Bank and/or its licensor /s and are protected under intellectual property
          and other applicable laws.. <br /> <br />

          11.2. You shall not (and shall not allow third parties) to copy, modify,
          create any derivative work from, reverse engineer, reverse assemble or
          otherwise attempt to discover any source code, sell, assign, sublicense,
          transfer any right or grant any security interest in the Proprietary Items,
          nor disclose the same..<br /> <br />

          11.3. You further agree that we may disclose, preserve or maintain any
          information, message, material, correspondence, data, communication
          and/or notification provided by you in connection with the use of the
          facility
          <ol style={{ listStyleType: "lower-alpha" }}>
            <li>if required to do so by law, government rule or regulation, or
              legal process.</li>
            <li>if the Bank has a good faith belief that such disclosure is necessary to comply with the law, government rule or regulation, or legal
              process.</li>
            <li>to enforce these Terms & Conditions.</li>
            <li>to respond to claims that such information, message, material,
              correspondence, data, communication, and/or notification violates
              the rights of third parties.</li>
            <li>to respond to your request for customer service; and/or</li>
            <li>to protect the Bank’s rights and property, its customers and/ or
              the general public.</li>
          </ol>
        </Typography>

        <br />

        <Typography variant="h6" color="primary" className={classes.bold}>
          12. Miscellaneous provisions
        </Typography>

        <Typography variant="body1" gutterBottom>
          12.1. Liability Limitation. The Bank’s entire liability in connection with the
          online facility shall be limited to the amount of fees you paid for the use
          and availment of the facility or the amount of the reasonable actual and
          direct loss or damage you suffered whichever is lower. We shall not be
          liable for any special, consequential or indirect damage you suffered
          from the use or availment of the facility. This Provision shall survive the
          termination or suspension of the facility.<br /> <br />

          12.2. Bank Secrecy Laws. You hereby acknowledge that it is aware of,
          understands the effect of, and agrees and undertakes to, and cause all
          the Users to observe bank secrecy laws, including but not limited to the
          provisions of Republic Act No. 1405, as amended, Republic Act. No.
          6426, as amended, Section 55.1 of Republic Act No. 8791 and other
          applicable laws or regulations (collectively, the “Bank Secrecy Laws”) in
          connection with the use and availment of the facility to access and/or do
          transactions on Third Party Account/s. You further agree and undertakes
          that it will not, and covenants that all the Users will not do anything
          which will cause the Bank to violate any provision of the Bank Secrecy
          Laws or otherwise be guilty of an offense thereunder. You agree that you
          shall be solidarily liable with the Bank should your or your user’s disclosure of information relative to Third Party Account/s, and the enrollment
          and use of such Accounts in the facility result to a violation by the Bank
          of the Bank Secrecy Laws.<br /> <br />

          12.3. E-Commerce Act. The provisions of the Electronic Commerce Act of
          2000 (R.A. 8792) and its Implementing Rules and Regulations, including
          Amendments and supplements thereto (“E-Commerce Act”), shall apply
          to this facility and the use and availment of transaction in this facility, in
          so far as said provisions are consistent with the Terms & Conditions of
          this Agreement. In the event of inconsistency between the provisions of
          the E-Commerce Act and Agreement, the latter shall prevail.<br /> <br />

          12.4. Confidentiality Obligation. You shall keep and cause your Users
          and/or other persons you authorized to have access to the facility, to
          keep and maintain the strict confidentiality of any and all messages,
          materials, information, communications, correspondences, data, notifications received, recorded, transmitted, generated, stored, processed,
          retrieved and/or produced electronically by the facility. This confidentiality obligation shall survive the termination or suspension of this facility.
          12.5. Force Majeure. We shall not be liable for any damage or delays
          caused by or arising out of force majeure, namely, typhoons, floods,
          earthquakes, calamities or other Acts of God, public disturbances, war,
          riots, lock-outs or strikes, coup d’état, embargo pandemic and other similar events beyond the control of the Bank,<br /> <br />

          12.6. We may at any time, amend any of these terms and conditions as it
          may deem necessary for the best interest of both parties, upon sixty (60)
          days’ notice to you prior to the implementation of any amendments. You
          hereby agree to be bound by such amendments.
          12.7. You agree to be bound by the General Terms and Conditions Governing EastWest Bank Accounts <a href="https://www.eastwestbanker.com/pages/general-terms-and-conditions-governing-eastwest-deposit-accounts" target="_blank">(https://www.eastwestbanker.com/pages/general-terms-and-conditions-governing-eastwest-deposit-accounts)</a> and by the Privacy Statement and the Privacy Statement, which can
          be found in EastWest corporate website <a href="https://www.eastwestbanker.com/privacystatement" target="_blank">(https://www.eastwestbanker.com/privacystatement)</a>, which are made part of this Agreement, in so
          far as they are consistent herewith.<br /> <br />

          12.8. Our failure to demand strict compliance with any of these terms
          and conditions shall not be construed as a waiver thereof. Any waiver to
          be effective shall be made in writing and signed by us.
          12.9. You shall ensure and hereby warrants that you and your User/s
          have clearly understood these terms and conditions and the procedures
          governing, the use and availment of the facility, and that you are fully aware and hereby assumes the potential risks arising from the use of
          the facility. <br /> <br />

          12.10. These terms and conditions and the interpretation and implementation hereof shall be governed by Philippine laws and shall be subject
          to the applicable rules and regulations of the Bangko Sentral Ng Pilipinas, government, telecommunications and other regulatory authorities,
          and the business rules, policies, procedures of the Bank governing this
          facility. <br /> <br />

          12.11. All suits arising out of these terms and conditions shall be exclusively lodged in the proper courts of Taguig City. <br /> <br />

          12.12. You shall not assign any of its rights and obligations under these
          terms and conditions without our prior written consent. <br /> <br />

          12.13. Should any of these terms and conditions be declared by competent authority as invalid, all other terms and conditions not affected by
          said invalidity shall remain effective and binding upon the parties. From
          the interpretation or implementation of these terms and conditions and/
          or the use or your availment of this facility, the parties hereby undertake
          to exert maximum efforts to resolve such dispute or controversy amicably
          within a period of THIRTY (30) days from the date question or controversy arose. During such period, the parties are prohibited from filing any
          case or complaint in a court of law or administrative and quasi-judicial
          body. Only when the aforementioned 30-day period shall have already
          elapsed without the parties reaching an amicable settlement may the
          aggrieved party file the necessary action in the appropriate Philippine
          court of law, administrative or quasi-judicial body. <br /> <br />

          12.14. Each of the parties agrees to execute and deliver all such further
          instruments, and to do, and perform all such further acts and things as
          shall be necessary or convenient to carry out these terms and conditions.

        </Typography>

      </div>
    </>
  );
});

export default withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: null,
      };
      this.handleChange = (panel) => (event, expanded) => {
        this.setState({
          expanded: expanded ? panel : false,
        });
      };
    }
    render() {
      return (
        <>
          <div id="pageBanner">
            <RenderPageBanner
              banner="/images/eastwestbank-supportsecurity-faqs-banner.jpg"
              bgColor="#fff"
            >
              <RenderSupportHeader
                section="Terms of Use"
                color="primary"
                page=""
              />
            </RenderPageBanner>
          </div>
          <section className="greyBG">
            <Grid container className="gridContainer">
              <Grid item xs={12} md={8}>
                <TermsOfUseText />
              </Grid>
              <Hidden smDown>
                <SupportQuickLinks
                  pagetitle="Back to Home"
                  link="/"
                  fontColor="primary"
                />
              </Hidden>
            </Grid>
          </section>
        </>
      );
    }
  }
);
